import React from "react";
import { useIntl } from "react-intl";
import { Tag } from "antd";

const PendingBranches = (props) => {
  const { record } = props;
  const intl = useIntl();

  return (
    <div>
      {record.branches && record.branches.length > 0 ? (
        record.branches.map((branch) => (
          <Tag key={branch.name}>{branch.name}</Tag>
        ))
      ) : (
        <Tag>
          {intl.formatMessage({
            id: "app.users.allBranches",
          })}
        </Tag>
      )}
    </div>
  );
};

export default PendingBranches;
